require('./RASuitabilityTestSuccess.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');
const { withRouter } = require('react-router-dom');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @components
const {
    SignaturePattern,
} = require('components/signaturePattern/signaturePattern');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const RASuitabilityTestAccordion = require('../../../components/commons/RASuitabilityTestAccordion/RASuitabilityTestAccordion');
const WebappRender = require('components/conditionalRender/webappRender');
const RASuitabilityTestResultChangeModal = require('../../../components/RASuitabilityTestResultChangeModal/RASuitabilityTestResultChangeModal');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const DateHelper = require('utilities/dateHelper');

// @constants
const { MULTIPLE_OPERATIONS } = require('constants/operationTypes');
const regexpRebalancing = /_rebalancing$/;
const { DATE_FORMAT_COMPLETE } = require('constants/index');
const {
    GOAL_TRACKING_URL,
    MYPROFILE_BROKER_ROBO_URL,
    PORTFOLIO_TRACKING_URL,
    RA_GOAL_NOTIFICATION_MODIFIER_IMPORTANT,
    RA_GOAL_NOTIFICATION_MODIFIER_WARNING,
    RA_SUITABILITY_TEST_HIRE_OPERATION,
    RA_SUITABILITY_TEST_MODIFYGOAL_OPERATION,
    RA_SUITABILITY_TEST_MODIFYPORTFOLIO_OPERATION,
    RA_SUITABILITY_TEST_STATUS,
    SUITABILITY_TEST_STATUS_URL,
} = require('../../../raConstants/index');
const {
    MODIFY_SUITABILITY_TEST,
    SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST,
    SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST_COUNTRIES,
    EVIDENCE_WEALTH_SUITABILITY_TEST,
} = require('constants/flagBasedFeatures');

class RASuitabilityTestSuccess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isStrategyChangeModalOpen: false,
        };
        this.handleReviseSuitabilityTest = this.handleReviseSuitabilityTest.bind(
            this,
        );
        this.handleStrategyChangeModalToggle = this.handleStrategyChangeModalToggle.bind(
            this,
        );
        this.handleGoBack = this.handleGoBack.bind(this);
        this.buildSignaturePatter = this.buildSignaturePatter.bind(this);
    }

    handleReviseSuitabilityTest() {
        const { isReviewInProgress, resetTestCompleted } = this.props;
        resetTestCompleted();
        isReviewInProgress();
    }

    buildInfoText() {
        const { newTestScenario } = this.props;
        const isRebalancing = regexpRebalancing.test(newTestScenario);
        const type = isRebalancing
            ? RA_GOAL_NOTIFICATION_MODIFIER_WARNING
            : RA_GOAL_NOTIFICATION_MODIFIER_IMPORTANT;
        return (
            <div className="ra-suitability-test-success__info-text">
                <OKMessage type={type} modifier="dark-bg" title={isRebalancing}>
                    <div className="ra-goal-notification__info">
                        <FormattedText value={newTestScenario} />
                    </div>
                </OKMessage>
            </div>
        );
    }

    handleGoBack() {
        const { immSuitabilityTest } = this.props;
        const isTestFrom = immSuitabilityTest.get('isTestFrom');
        const portfolioId = immSuitabilityTest.get('portfolioId');
        let destinationURL;
        switch (isTestFrom) {
            case RA_SUITABILITY_TEST_HIRE_OPERATION:
                destinationURL = MYPROFILE_BROKER_ROBO_URL;
                break;
            case RA_SUITABILITY_TEST_MODIFYGOAL_OPERATION:
                destinationURL = `${GOAL_TRACKING_URL}/${portfolioId}`;
                break;
            case RA_SUITABILITY_TEST_MODIFYPORTFOLIO_OPERATION:
                destinationURL = `${PORTFOLIO_TRACKING_URL}/${portfolioId}`;
                break;
            case RA_SUITABILITY_TEST_STATUS:
                destinationURL = SUITABILITY_TEST_STATUS_URL;
                break;
            default:
                destinationURL = MYPROFILE_BROKER_ROBO_URL;
        }
        this.props.history.push(destinationURL);
    }

    buildSignaturePatter() {
        const { immSuitabilityTest, immFlagBasedFeatures } = this.props;

        const PDFInbase64 = immSuitabilityTest.get('generatedPdf');
        const PDFInbase64Fetching = immSuitabilityTest.get('fetchingPdf');
        const PDFInbase64Error = immSuitabilityTest.get('errorOnPdf');

        const operationProcessId = immSuitabilityTest.get('operationProcessId');
        const paramsForDms = {
            operationProcessId: operationProcessId,
            evidenceType: 'SIGN_DOCUMENT',
        };

        const operationParams = {
            requestMulti: [{ serviceCode: '158' }, { serviceCode: '101' }],
            ...(immFlagBasedFeatures.get(EVIDENCE_WEALTH_SUITABILITY_TEST) &&
                operationProcessId && {
                    ...paramsForDms,
                }),
        };
        return (
            <SignaturePattern
                printTitleValue={'roboPrintTitle-testResult'}
                operationType={MULTIPLE_OPERATIONS}
                operationParams={operationParams}
                customClassName="ra-suitability-test-success__signature-pattern"
                isWealth={true}
                pdfToShow={PDFInbase64}
                pdfToShowFetching={PDFInbase64Fetching}
                pdfToShowError={PDFInbase64Error}
            />
        );
    }

    buildOtpSection() {
        const {
            clientName,
            isDisabled,
            onConfirm,
            immSuitabilityTest,
            immFlagBasedFeatures,
        } = this.props;

        const operationProcessId = immSuitabilityTest.get('operationProcessId');
        const legalTextSignature = __CONTACT_CENTER__ && (
            <BlockInfo extraClass="ra-suitability-test-success__block-info">
                <FormattedText
                    value="raSuitabilityTestSuccess-legalTextSignature"
                    injectedStrings={[clientName]}
                />
            </BlockInfo>
        );

        let content = <LoadingSection />;
        if (
            immFlagBasedFeatures.get(EVIDENCE_WEALTH_SUITABILITY_TEST) &&
            operationProcessId
        ) {
            content = this.buildSignaturePatter();
        } else if (
            !immFlagBasedFeatures.get(EVIDENCE_WEALTH_SUITABILITY_TEST)
        ) {
            content = this.buildSignaturePatter();
        }

        return (
            <React.Fragment>
                <FormattedText
                    className="ra-suitability-test-success__signature-pattern-title"
                    value="raSuitabilityTestSuccess-otpTitle"
                />
                <FormattedText
                    className="ra-suitability-test-success__signature-pattern-description"
                    value="raSuitabilityTestSuccess-otpDescription"
                />
                {content}
                <div className="ra-suitability-test-success__button">
                    <OKButton onClick={onConfirm} disabled={isDisabled}>
                        <FormattedText value="raSuitabilityTestSuccess-ctaButton" />
                    </OKButton>
                </div>
                {legalTextSignature}
            </React.Fragment>
        );
    }

    buildOtpSectionUnsuccessTest() {
        const { isDisabled, onConfirm, immSuitabilityTest } = this.props;
        const operationParams = {
            requestMulti: [{ serviceCode: '158' }, { serviceCode: '101' }],
        };
        const PDFInbase64 = immSuitabilityTest.get('generatedPdf');
        const PDFInbase64Fetching = immSuitabilityTest.get('fetchingPdf');
        const PDFInbase64Error = immSuitabilityTest.get('errorOnPdf');
        return (
            <React.Fragment>
                <SignaturePattern
                    printTitleValue={'roboPrintTitle-testResult'}
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={operationParams}
                    customClassName="ra-suitability-test-success__signature-pattern"
                    pdfToShow={PDFInbase64}
                    pdfToShowFetching={PDFInbase64Fetching}
                    pdfToShowError={PDFInbase64Error}
                />
                <div className="ra-suitability-test-success__button">
                    <OKButton onClick={onConfirm} disabled={isDisabled}>
                        <FormattedText value="raSuitabilityTestSuccess-ctaButton" />
                    </OKButton>
                </div>
            </React.Fragment>
        );
    }

    buildUnsuccessDetailsSection() {
        const today = moment();
        const lastResultInvestorLabel = formatText(
            'raSuitabilityTestSuccess-title',
        );
        return (
            <div>
                <div className="ra-suitability-test-success__details-header">
                    <div className="ra-suitability-test-success__details-icon-success" />
                    <h3 className="ra-suitability-test-success__details-title">
                        <FormattedText value="raSuitabilityTestSuccessDetails-raSuitabilityTestSuccessDetails_title" />
                    </h3>
                    <div className="ra-suitability-test-success__details-separator"></div>
                </div>

                <div className="ra-suitability-test-success__details-body">
                    <FormattedText value="raSuitabilityTestValid-firstParagraph" />
                    <div className="ra-suitability-test-success__details-accordion-info">
                        <div className="ra-suitability-test-accordion__investor-label">
                            {lastResultInvestorLabel}
                        </div>
                        <div className="ra-suitability-test-accordion__investor-type">
                            <FormattedText value="raSuitabilityTest-unsuccessTest_profile" />
                        </div>
                    </div>
                    <div className="ra-suitability-test-success__details-date-title">
                        <FormattedText value="consultMiFID-dateLastEvaluation" />
                    </div>
                    <div className="ra-suitability-test-success__details-date-info">
                        {DateHelper.buildFormattedDate(
                            today,
                            DATE_FORMAT_COMPLETE,
                        )}
                    </div>
                    <FormattedText value="raSuitabilityTestValid-raSuitabilityTestValid_footerTextSuitability" />
                </div>
                <div className="ra-suitability-test-success__details-divider" />
                <div className="ra-suitability-test-success__details-footer">
                    <OKButton onClick={this.handleGoBack} modifier="secondary">
                        <FormattedText value="raSuitabilityTestSuccessDetails-raSuitabilityTestSuccessDetails_ctaButton" />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildDetailsSection() {
        const { clientRiskProfile } = this.props;
        const today = moment();
        const lastResultInvestorLabel = formatText(
            'raSuitabilityTestSuccess-title',
        );
        return (
            <React.Fragment>
                <div className="ra-suitability-test-success__details-header">
                    <div className="ra-suitability-test-success__details-icon-success" />
                    <h3 className="ra-suitability-test-success__details-title">
                        <FormattedText value="raSuitabilityTestSuccessDetails-raSuitabilityTestSuccessDetails_title" />
                    </h3>
                    <div className="ra-suitability-test-success__details-separator"></div>
                </div>
                <div className="ra-suitability-test-success__details-body">
                    <FormattedText value="raSuitabilityTestValid-firstParagraph" />
                    <div className="ra-suitability-test-success__details-accordion-info">
                        <div className="ra-suitability-test-accordion__investor-label">
                            {lastResultInvestorLabel}
                        </div>
                        <div className="ra-suitability-test-accordion__investor-type">
                            {clientRiskProfile}
                        </div>
                    </div>
                    <div className="ra-suitability-test-success__details-date-title">
                        <FormattedText value="consultMiFID-dateLastEvaluation" />
                    </div>
                    <div className="ra-suitability-test-success__details-date-info">
                        {DateHelper.buildFormattedDate(
                            today,
                            DATE_FORMAT_COMPLETE,
                        )}
                    </div>
                    <FormattedText value="raSuitabilityTestValid-raSuitabilityTestValid_footerTextSuitability" />
                </div>
                <div className="ra-suitability-test-success__details-divider" />
                <div className="ra-suitability-test-success__details-footer">
                    <OKButton onClick={this.handleGoBack} modifier="secondary">
                        <FormattedText value="raSuitabilityTestSuccessDetails-raSuitabilityTestSuccessDetails_ctaButton" />
                    </OKButton>
                </div>
            </React.Fragment>
        );
    }

    handleStrategyChangeModalToggle() {
        this.setState({
            isStrategyChangeModalOpen: !this.state.isStrategyChangeModalOpen,
        });
    }

    buildSustainabilityProfile() {
        const { immResults, immFlagBasedFeatures } = this.props;
        if (
            immFlagBasedFeatures.get(
                SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST,
            ) ||
            immFlagBasedFeatures.get(
                SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST_COUNTRIES,
            )
        ) {
            const sustainabilityProfileText = immResults.get(
                'sustainabilityProfileDescription',
            );
            return <p>{sustainabilityProfileText}</p>;
        }
        return null;
    }

    render() {
        const {
            clientName,
            disclaimer,
            headerDescription,
            immFlagBasedFeatures,
            immSuitabilityTest,
            profile,
            secondParagraph,
            showTextStatus,
            newMaxTypeOfProduct,
            oldMaxTypeOfProduct,
            newTestScenario,
            continueWithUnsuccess,
        } = this.props;

        const { isStrategyChangeModalOpen } = this.state;

        const isRebalancing = regexpRebalancing.test(newTestScenario);

        const legalTextDescription = __CONTACT_CENTER__ && (
            <div className="ra-suitability-test-success__description">
                <span className="ra-suitability-test-success__description-text">
                    <FormattedText
                        value="raSuitabilityTestSuccess-legalTextDescription"
                        injectedStrings={[clientName]}
                    />
                    <br />
                    <FormattedText value="raSuitabilityTestSuccess-legalTextDescriptionNext" />
                </span>
            </div>
        );

        const linkElement = (
            <OKLink
                className="ra-suitability-test-success__revise-link"
                modifier="emphasize"
                onClick={this.handleReviseSuitabilityTest}
            >
                <FormattedText value="raSuitabilityTestSuccess-raSuitabilityTestSuccess_reviseLink" />
            </OKLink>
        );

        const lastResultInvestorLabel = (
            <FormattedText value="raSuitabilityTestSuccess-title" />
        );

        const sustainabilityProfile = this.buildSustainabilityProfile();

        const linkReviseTest =
            immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST) &&
            !immSuitabilityTest.get('successDone') ? (
                <div className="ra-suitability-test-success__revise-link">
                    <FormattedTextWithComponents
                        value="raSuitabilityTestSuccess-raSuitabilityTestSuccess_reviseText"
                        injectedComponents={[linkElement]}
                    />
                </div>
            ) : null;
        const infoText = showTextStatus ? this.buildInfoText() : null;
        const infoTextForCC = __CONTACT_CENTER__ && showTextStatus && (
            <BlockInfo extraClass="ra-suitability-test-success__block-info">
                <FormattedText value={newTestScenario} />
            </BlockInfo>
        );
        const footerContent =
            immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST) &&
            immSuitabilityTest.get('successDone')
                ? this.buildDetailsSection()
                : this.buildOtpSection();

        const suitabilityTestModal =
            showTextStatus && isRebalancing ? (
                <RASuitabilityTestResultChangeModal
                    isOpen={isStrategyChangeModalOpen}
                    onModalToggle={this.handleStrategyChangeModalToggle}
                    newMaxTypeOfProduct={newMaxTypeOfProduct}
                    oldMaxTypeOfProduct={oldMaxTypeOfProduct}
                    onReviseButtonClick={this.handleReviseSuitabilityTest}
                />
            ) : null;

        const seeAvailablePortfoliosLink =
            showTextStatus && isRebalancing ? (
                <div className="ra-suitability-test-accordion__investor-description-text">
                    <OKLink
                        extraClass="ra-suitability-test-success__available-porfolios-link"
                        onClick={this.handleStrategyChangeModalToggle}
                        modifier="emphasize"
                    >
                        <FormattedText value="raSuitabilityTestSuccess-raSuitabilityTestSuccess_availablePortfoliosLink" />
                    </OKLink>
                </div>
            ) : null;

        const accordionHeaderDescription = (
            <div className="ra-suitability-test-accordion__investor-description-text">
                {headerDescription}
                {seeAvailablePortfoliosLink}
            </div>
        );
        if (continueWithUnsuccess) {
            const footerUnsuccessContent = immSuitabilityTest.get('successDone')
                ? this.buildUnsuccessDetailsSection()
                : this.buildOtpSectionUnsuccessTest();
            return (
                <section className="ra-suitability-test-success">
                    <div className="ra-suitability-test-success__unsuccess-header">
                        <p>
                            <FormattedText value="raSuitabilityTest-unsuccessTest_title1" />
                        </p>
                        <p>
                            <FormattedText value="raSuitabilityTest-unsuccessTest_title2" />
                        </p>
                    </div>
                    <div className="ra-suitability-test-success__profile-section">
                        <div className="ra-suitability-test-success__unsuccess-profile">
                            <div className="ra-suitability-test-success__unsuccess-profile-icon-container">
                                <i className="ra-suitability-test-success__unsuccess-profile-icon" />
                            </div>
                            <div className="ra-suitability-test-success__unsuccess-profile-text-container">
                                <div className="ra-suitability-test-success__unsuccess-profile-label">
                                    <FormattedText value="raSuitabilityTest-unsuccessTest_profileLabel" />
                                </div>
                                <div className="ra-suitability-test-success__unsuccess-profile-profile">
                                    <FormattedText value="raSuitabilityTest-unsuccessTest_profile" />
                                </div>
                            </div>
                        </div>
                        <div className="ra-suitability-test-success__unsuccess-content">
                            <div className="ra-suitability-test-success__unsuccess-content-title">
                                <FormattedText value="raSuitabilityTest-unsuccessTest_readingTitle" />
                            </div>
                            <div className="ra-suitability-test-success__unsuccess-content-paragraph">
                                <FormattedText value="raSuitabilityTest-unsuccessTest_reading" />
                            </div>
                        </div>
                        <BlockInfo>
                            <FormattedText value="raSuitabilityTest-unsuccessTest_disclaimerContent" />
                        </BlockInfo>
                        {footerUnsuccessContent}
                    </div>
                </section>
            );
        }
        return (
            <section className="ra-suitability-test-success">
                {suitabilityTestModal}
                <div className="ra-suitability-test-success__top-disclaimer no-print-out">
                    {disclaimer}
                </div>
                <div className="ra-suitability-test-success__profile-section">
                    <RASuitabilityTestAccordion
                        alwaysShowSeparator
                        clientRiskProfile={profile}
                        headerRiskProfileDescription={
                            accordionHeaderDescription
                        }
                        productDescription={secondParagraph}
                        lastResultInvestorLabel={lastResultInvestorLabel}
                        legalTextDescription={legalTextDescription}
                        sustainabilityProfile={sustainabilityProfile}
                    />
                    {linkReviseTest}
                    <WebappRender>{infoText}</WebappRender>
                    {infoTextForCC}
                    {footerContent}
                </div>
                <div className="ra-suitability-test-success__email-disclaimer">
                    <i className="icon icon-informacion ra-suitability-test-success__info-icon" />
                    <FormattedText
                        className="ra-suitability-test-success__email-disclaimer-text"
                        value="raSuitabilityTestSuccess-emailNotification"
                        injectedStrings={[this.props.email]}
                    />
                </div>
            </section>
        );
    }
}

RASuitabilityTestSuccess.propTypes = {
    continueWithUnsuccess: false,
};

RASuitabilityTestSuccess.propTypes = {
    cancelURL: PropTypes.string.isRequired,
    clientName: PropTypes.string,
    clientRiskProfile: PropTypes.string,
    disclaimer: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    headerDescription: PropTypes.string,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    immResults: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    continueWithUnsuccess: PropTypes.bool.isRequired,
    isReviewInProgress: PropTypes.func.isRequired,
    newMaxTypeOfProduct: PropTypes.number.isRequired,
    newTestScenario: PropTypes.string.isRequired,
    oldMaxTypeOfProduct: PropTypes.number.isRequired,
    onConfirm: PropTypes.func.isRequired,
    profile: PropTypes.string.isRequired,
    resetTestCompleted: PropTypes.func.isRequired,
    secondParagraph: PropTypes.string,
    showTextStatus: PropTypes.string.isRequired,
    getTestPDF: PropTypes.func.isRequired,
};

module.exports = withRouter(RASuitabilityTestSuccess);
